import { TRootState }                                   from 'Redux/Reducers';
import { ISettingsState }                               from 'Redux/Slices/Settings/SettingsSlice';

export const getSettings = (state: TRootState): ISettingsState['entries'] => state.settings.entries;
